import VueQr from "vue-qr/src/packages/vue-qr.vue"
// NOTE: this can only be loaded on the client side, so the filename
// has to have `.client` in the name.
export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    nuxtApp.vueApp.component("vue-qr", VueQr, {})
  }
})
